import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation, QueryList,SecurityContext } from '@angular/core';
import { ITableData, DataTablesService } from './data-tables.service';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { SpinkitComponent } from '@coreui/angular/lib/spinkit/spinkit.component';
import { AppToastComponent as ToastComp } from '../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../services/http-service/http.service'
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LocalInterfaceService } from '../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../services/storege-service/storage.service';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName } from '@angular/forms';
import { ExcelJson, ExportExcelService } from '../../services/export-excel/export-excel.service';
import { ToolService } from '../../services/tool/tool.service';
import { HttpJavaService } from '../../services/http-java-service/http-java.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-data-tables',
  templateUrl: './data-tables.component.html',
  styleUrls: ['./data-tables.component.scss'],
  providers: [DataTablesService],
  encapsulation: ViewEncapsulation.None,
})
export class DataTablesComponent {
  filterQuery: string = '';
  private filterSubject: Subject<string> = new Subject<string>();
  private destroy$: Subject<boolean> = new Subject<boolean>();

  error: any;
  public dbData?;
  public dbTransactionData?;
  public isLoading: boolean = true;
  public currentIndex = 0;
  // public filterQuery = '';
  public btnLang: string;
  public langDir: string = "ltr";
  // public toasterService: ToasterService;
  // // public toasterconfig: ToasterConfig =
  // // new ToasterConfig({
  // //   tapToDismiss: true,
  // //   timeout: 5000
  // // });
  public facilityId = '';
  public amount = '';
  public paymentMethod = '';
  public currency = '';
  public staffId = '';
  public sharedWallet = 'N';
  public paymentMethods?;
  public filterQueryForPaymentTransfer = '';

  simpleForm: FormGroup;
  title = 'ng';
  langs = ['en', 'ar'];

  // tooltipProps = {
  //   interactive: true,
  //   allowHTML: true,
  //   appendTo: 'parent',
  //   theme: 'c-tooltip',
  //   trigger: 'mouseenter focus touchstart',  // The tooltip will be triggered by hover, focus, or touch
  //   content: 'This is a tooltip on hover!',
  // };

  // sanitize(value: string): string {
  //   return this.sanitizer.sanitize(SecurityContext.HTML, value) || '';
  // }
  public currentSelectedRecordData: any = {};


  public ngOnInit(): void {
    let browserlang = this.translateService.getBrowserLang();
    if (this.langs.indexOf(browserlang) > -1) {
      this.translateService.setDefaultLang(browserlang);
      this.btnLang = 'English';
      this.langDir = 'rtl';
    } else {
      this.translateService.setDefaultLang('en');
      this.btnLang = "العربية";
      this.langDir = 'ltr';
    }
    this.filterSubject
      .pipe(
        debounceTime(500), // Wait 500ms after the last keystroke
        distinctUntilChanged(), // Only emit if the value has changed
        takeUntil(this.destroy$) // Automatically unsubscribe on component destruction
      )
      .subscribe((query: string) => {
        this.searchCustomer(query);
      });
  }
  onFilterQueryChange(query: string): void {
    this.filterSubject.next(query); // Emit the current query
  }

  constructor(
    private dataTableService: DataTablesService,
    public translateService: TranslateService,
    public titleService: Title,
    public router: Router,
    public route: ActivatedRoute,
    private http: HttpClient,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private httpService: HttpService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    private exportExcelService: ExportExcelService,
    public toolService: ToolService,
    private javaService: HttpJavaService
    // private sanitizer: DomSanitizer
  ) {
    //this.toasterService = toasterService;
    this.isLoading = true;
    this.route.queryParams.subscribe(async params => {
      this.facilityId = this.storageSrv.getFacilityId();
      this.currency = this.storageSrv.getFacilityCcy();
      this.staffId = this.storageSrv.getUser();
      this.sharedWallet = this.storageSrv.getSharedWallet();
      await this.loadCustomers(this.facilityId);
      await this.loadPaymentMethods(this.facilityId);
      this.createForm();
    });
  }

  @ViewChild('walletModal', { static: false }) public walletModal: ModalDirective;
  @ViewChild('paymentTransferModal', { static: false }) public paymentTransferModal: ModalDirective;

  createForm() {
    this.simpleForm = this.fb.group({
      amount: [this.amount, [Validators.required]],
      paymentMethod: [this.paymentMethod, [Validators.required]],
    }, {});
  }
  get f() { return this.simpleForm.controls; }

  loadCustomers = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getCustomer(facilityId)
        .then(res => {
          this.dbData = res;
          this.isLoading = false;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally(() => this.isLoading = false);
    });
  }

  public showWallet(userId: any, index,user?:any) {
    this.currentSelectedRecordData = this.dbData.content.find(c => c.id === userId);
    if(!this.currentSelectedRecordData){
      this.currentSelectedRecordData = user;
    }
    this.loadWalletTransactions(userId);
  }

  loadWalletTransactions = (userId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.localInterfaceSrv.getWalletTransactionsForFacility(userId)
        .then(res => {
          this.dbTransactionData = res.content;
          this.dbTransactionData.transactions = res.content.transactions;
          this.dbTransactionData.count = res.count;
          this.isLoading = false;
          this.walletModal.show();
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
        })
        .finally(() => this.isLoading = false);
    });
  }
  loadPaymentMethods = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getPaymentMethods(facilityId)
        .then(res => {
          this.paymentMethods = res;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.desc, "Error");
        })
        .finally(() => this.isLoading = false);
    });
  }

  actionCustomerWallet = (userId, actionType) => {
    this.amount = this.f['amount'].value;
    this.paymentMethod = this.f['paymentMethod'].value;

    if (this.paymentMethod.length <= 1) {
      this.toastr.warning("Payment Method not selected", "Warning");
      return;
    }
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        userId: userId
      };
      if (actionType == 'DEBIT') {
        this.localInterfaceSrv.actionCustomerWallet(userId, this.staffId, actionType, this.amount, this.currency, this.paymentMethod)
          .then(async res => {
            resolve(res);
            this.toastr.success("Customer Debited", "Success");
            this.walletModal.hide();
            this.route.queryParams.subscribe(async params => {
              await this.loadCustomers(this.facilityId);
            });
            //window.location.reload()
          })
          .catch(err => {
            reject(err);
            this.toastr.error(err.desc, "Error");
            this.walletModal.hide();
          })
          .finally(() => this.isLoading = false);
      } else if (actionType == 'CREDIT') {
        this.localInterfaceSrv.actionCustomerWallet(userId, this.staffId, actionType, this.amount, this.currency, this.paymentMethod)
          .then(async res => {
            resolve(res);
            this.toastr.success("Customer Credited", "Success");
            this.walletModal.hide();
            this.route.queryParams.subscribe(async params => {
              await this.loadCustomers(this.facilityId);
            });
            //window.location.reload()
          })
          .catch(err => {
            reject(err);
            this.toastr.error(err.desc, "Error");
            this.walletModal.hide();
          })
          .finally(() => this.isLoading = false);
      }
    });
  }

  public toInt(num: string) {
    return +num;
  }

  public sortByWordLength = (a: any) => {
    return a.name.length;
  }

  public getDate(regDate: string) {
    const date = new Date(regDate);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    });
  }

  public showEdit(data: object) {
    this.router.navigate(['details'], { state: { data: data }, relativeTo: this.route });
  }
  public add() {
    this.router.navigate(['details'], { state: { createData: '' }, relativeTo: this.route });
  }
  goToBookings = (customerMobile) => {
    if(!customerMobile) return;
    customerMobile = customerMobile.replace('+', '').replace('-', '');
    this.router.navigate(['/booking'], { state: { customerMobile: customerMobile } });

  }
  exportToExcel() {
    // this.exportExcelService.exportTableElmToExcel(this.customersTable, 'customers');
    const customers = this.dbData?.content;
    const excelJsonData: Array<ExcelJson> = [];
    var excelFileName = 'customers';
    const customersJsonData: ExcelJson = {
      data: [
        {
          A: '#',
          B: 'Name',
          C: 'Mobile',
          D: 'Total Bookings',
          E: 'Total No Show',
          F: 'Status',
        },
      ],
      skipHeader: true,
    };
    customers.forEach((item, index) => {
      customersJsonData.data.push({
        A: index + 1,
        B: item?.customerName,
        C: item?.mobileNumber,
        D: item?.totalBookings,
        E: item?.totalNoShow,
        F: item?.userStatus,
      });
    });
    excelJsonData.push(customersJsonData);
    this.exportExcelService.exportJsonToExcel(excelJsonData, excelFileName);
  }

  transferPayment = () => {
    this.paymentTransferModal.show();
    this.walletModal.hide()
  }

  hidePaymentTransferModal = () => {
    this.paymentTransferModal.hide()
    this.walletModal.show();
    this.removeSelectedPlayer()
  }

  isBalanceZero(): boolean {
    const balance = +this.dbTransactionData.balance; // Convert to number
    return !isNaN(balance) && balance === 0; // Check if balance is 0
  }
  transferAmount = 0;
  transferPaymentConfirm = () => {
    if (!this.selectedPlayer) {
      this.toastr.error("Select Customer", "Error");
      return
    }

    if(this.transferAmount > this.dbTransactionData.balance){
      this.toastr.error("You can use maximum balance: " + this.dbTransactionData.balance, "Error");
      return;
    }

    if(this.transferAmount == 0){
      this.toastr.error("Invalid Amount", "Error");
      return;
    }

    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const transferData =  {
        "amount": this.transferAmount.toFixed(2),
        "facilityId":  this.facilityId,
        "senderId":this.currentSelectedRecordData?.id,
        "receiverId":this.selectedPlayer?.id
      }
      this.localInterfaceSrv
        .balanceTransferBetweenCustomers(transferData)
        .then(async (res) => {
          this.toastr.success('Balance Shared successfully');
          this.postBalanceShare()
          this.isLoading = false;
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          this.toastr.error(err?.error?.result?.desc, 'Error');
        })
        .finally(() => {
          this.isLoading = false;
        });
    });

  }

  filteredOptions: any[] = []; // Options displayed in the dropdown
  selectedPlayer: any = null; // Selected player

  filterOptions() {
    const query = this.filterQueryForPaymentTransfer.toLowerCase();
    this.filteredOptions = this.dbData.content.filter(
      item =>
        item.customerName.toLowerCase().includes(query) ||
        item.mobileNumber.includes(query)
    );
  }

  // Handle selection of an option
  selectOption(item: any) {
    this.selectedPlayer = item; // Set the selected player
    this.filterQueryForPaymentTransfer = ''; // Clear the search input
    this.filteredOptions = []; // Clear the dropdown
  }

  removeSelectedPlayer() {
    this.selectedPlayer = null; // Reset the selected player
    this.filterQueryForPaymentTransfer = ''; // Reset the search input
  }

  postBalanceShare(){
    this.removeSelectedPlayer()
    this.paymentTransferModal.hide()
    this.walletModal.hide()
    this.currentSelectedRecordData=null;
  }

  searchedCustomers:any = [];
  isSearching: boolean = false;

  searchCustomer(keyword:any){
    if (keyword.trim()) {
      this.isSearching = true;
      this.isLoading = true;
      this.javaService.searchUserDashboard(keyword).then((resp: any) => {
        const customers = resp?.data?.content || [];
        this.searchedCustomers = customers;
      this.isLoading = false;
      }).catch((err) => {
        console.error("Search API Error:", err);
        this.isSearching = false;
      this.isLoading = false;
      });
    } else {
      this.clearSearch();
    }

  }
  clearSearch(): void {
    this.isSearching = false;
    this.searchedCustomers = [];
    this.isLoading = false;
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
